import { useTeamTree } from '@internal/backstage-plugin-common-library-react';
import { DateTime } from 'luxon';
import React, { createContext, useContext, useMemo } from 'react';

import { useEntity } from '@backstage/plugin-catalog-react';

import { useGetCategoriesData } from '../hooks/useGetCategoriesData';
import { CategoryData } from '../types';
import { toStandardISO } from '../utils';

interface ScorecardDataContextType {
  categoriesData: CategoryData[] | null;
  loading: boolean;
}

const ScorecardDataContext = createContext<ScorecardDataContextType>({
  categoriesData: null,
  loading: true,
});

export const ScorecardDataProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const { entity } = useEntity();
  const { teamTree } = useTeamTree(entity.metadata.name);
  const teamTreeData = useMemo(() => teamTree?.tree, [teamTree?.tree]);
  const startDate = useMemo(
    () => toStandardISO(DateTime.now().startOf('month')),
    [],
  );
  const endDate = useMemo(
    () => toStandardISO(DateTime.now().endOf('month')),
    [],
  );

  const { loading, value: categoriesData } = useGetCategoriesData(
    teamTreeData,
    startDate,
    endDate,
    'month',
  );

  return (
    <ScorecardDataContext.Provider value={{ categoriesData, loading }}>
      {children}
    </ScorecardDataContext.Provider>
  );
};

export const useScorecardData = () => useContext(ScorecardDataContext);
